import { MenuItem } from '@mui/material'
import { ProcessNowTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/ProcessNowTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ProcessNowDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const ProcessNowDropdownOption: FC<ProcessNowDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(ProcessNowTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_process_now_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_process_now" defaultMessage="Process now" />
        </MenuItem>
    )
}
